import { render, staticRenderFns } from "./DetailTransfers.vue?vue&type=template&id=6b69571e&scoped=true&"
import script from "./DetailTransfers.vue?vue&type=script&lang=js&"
export * from "./DetailTransfers.vue?vue&type=script&lang=js&"
import style0 from "./DetailTransfers.vue?vue&type=style&index=0&id=6b69571e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b69571e",
  null
  
)

export default component.exports